export default __webpack_public_path__ + "static/media/pp-icon.6ad76bd0.webp";